import containerPage from "../../components/Layout/container.module.css";
import { Outlet } from "react-router-dom";

const Pescadores = () => {
  return (
    <div className={containerPage.containerPage} style={{ paddingLeft: "0px" }}>
      <Outlet />
    </div>
  );
};

export default Pescadores;